import { render, staticRenderFns } from "./GuestIpRanges.vue?vue&type=template&id=1fb559f4&"
import script from "./GuestIpRanges.vue?vue&type=script&lang=js&"
export * from "./GuestIpRanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports